import type { ModuleInjectionTable } from '@open-mercato/shared/modules/widgets/injection'

export const injectionTable: ModuleInjectionTable = {
  'customers.company.detail:details': {
    widgetId: 'compliance.injection.compliance-status-badge',
    priority: 40,
  },
}

export default injectionTable
